module.exports = __webpack_public_path__ + "img/choose-up-12_2.ff6e9ff3.png";